import { Texts, Media } from "../../Object";
import { Grid, Space } from '../index'
import { Scroll } from "../../Animation";
import { AnimatePresence, motion } from "framer-motion";
import { useState, useMemo } from "react";

const QA = (props) => {
  const length = Number(props.length);
  const slug = String(props.slug);
  const [activeIndex, setActiveIndex] = useState();

  const Item = (props) => {
    const index = props.index;
    const active = activeIndex == index ? true : false;

    const Question = () => {
      return (
        <>
          <div className="c-qa__wrap--inner">
            <Texts
              class="c-qa__wrap--inner__text c-text--bold"
              slug={`${slug}/q${props.index}`}
            ></Texts>
            <div
              data-state={active ? 'active' : ''}
              className="p-img__toggle"
              onClick={() => {
                if (active) {
                  setActiveIndex();
                } else {
                  setActiveIndex(index);
                }
              }}
            ></div>
          </div>
        </>
      );
    };
    const questionMemo = useMemo(() => <Question />, []);

    const Answer = () => {
      return (
        <>
          <div className="c-qa__wrap--inner">
            <Texts
              class="c-qa__wrap--inner__text"
              slug={`${slug}/a${props.index}`}
            ></Texts>
          </div>
        </>
      );
    };

    return (
      <>
        <div className="c-qa__wrap">
          {questionMemo}
          <AnimatePresence mode="wait">
            {active && (
              <motion.div
                key={props.index}
                animate={{
                  opacity: 1,
                  height: "auto",
                }}
                initial={{
                  opacity: 0,
                  height: 0,
                }}
                exit={{
                  opacity: 0,
                  height: 0,
                }}
              >
                <Space size={["18px 0 0", "14px 0 0"]}>
                  <Answer></Answer>
                </Space>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </>
    );
  };

  let items = [];
  for (let i = 0; i < length; i++) {
    items.push(<Item key={i} index={i}></Item>);
  }

  const gridProps = {
    list: {
      dir: ["row"],
      layout: ["100%"],
      size: ["100%"],
      gap: ["40px"],
    },
  };

  return (
    <>
      <div>{items}</div>
    </>
  );
};

export default QA;